"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _gamepadIsSupported = _interopRequireDefault(require("./gamepadIsSupported"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: getGamepads returns a GamepadList, not an array
// https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
function _default() {
  if ((0, _gamepadIsSupported.default)()) {
    return navigator.getGamepads();
  }

  return [null, null, null, null];
}